'use client'

import { GoogleTagManager } from '@next/third-parties/google'
import { usePathname } from 'next/navigation'

import { FacebookPixelScript } from './facebook-pixel-script'
import ToltScript from './tolt-script'

interface AnalyticsScriptsProps {
  /**
   * GTM container ID. GA4 is configured as a tag inside the container,
   * so it must not be loaded separately here (that double-counts pageviews).
   */
  gtmId?: string
  facebookPixelId?: string
  toltId?: string
}

export const AnalyticsScripts = ({ gtmId, facebookPixelId, toltId }: AnalyticsScriptsProps) => {
  const pathname = usePathname()

  // Skip all analytics for embedded chat routes
  if (pathname?.startsWith('/chat')) {
    return null
  }

  // Each script is opt-in: a missing env var disables it instead of loading a broken tag.
  return (
    <>
      {gtmId && <GoogleTagManager gtmId={gtmId} />}
      {toltId && <ToltScript apiKey={toltId} />}
      {facebookPixelId && <FacebookPixelScript pixelId={facebookPixelId} />}
    </>
  )
}
